import { Alert, Grid, Stack } from "@mui/material";
import ContractHeroCard from "./ContractHeroCard";
import ContractNextActionCard from "./ContractNextActionCard";
import ContractPostActivationCard from "./ContractPostActivationCard";
import ContractProgressTracker from "./ContractProgressTracker";
import ContractSummaryCard from "./ContractSummaryCard";
import GuaranteeStatusCard from "./GuaranteeStatusCard";
import { CONTRACT_UX } from "./contractUxTheme";

/**
 * Phase 7.7.4 — Dense composed contract workspace layout.
 */
const ContractorContractPageLayout = ({
  ux,
  contract,
  onDownload,
  onView,
  onActionClick,
  onGuaranteeUploaded,
  actionSlot = null,
  nextActionOverride = undefined,
  showPostActivation = true,
}) => {
  if (!ux || ux.phase === "empty") {
    return (
      <Alert severity="info" data-testid="contract-empty-state" sx={{ py: 1 }}>
        اطلاعات پس از تکمیل فرآیند نمایش داده می‌شود.
      </Alert>
    );
  }

  const action =
    nextActionOverride === undefined ? ux.action : nextActionOverride;

  return (
    <Stack
      spacing={CONTRACT_UX.sectionGap}
      data-testid="contractor-contract-page-layout"
      dir="rtl"
      sx={{ bgcolor: CONTRACT_UX.bg, borderRadius: 2, p: { xs: 0, md: 0 } }}
    >
      <ContractHeroCard ux={ux} />
      <ContractProgressTracker steps={ux.progress?.steps || []} />

      {(action || actionSlot) && (
        <ContractNextActionCard
          action={action}
          onActionClick={onActionClick}
          primaryActionSlot={actionSlot}
        />
      )}

      <Grid container spacing={2}>
        <Grid item xs={12} md={ux.showGuarantee ? 6 : 12}>
          <ContractSummaryCard
            ux={ux}
            onDownload={onDownload}
            onView={onView}
          />
        </Grid>
        {ux.showGuarantee ? (
          <Grid item xs={12} md={6}>
            <GuaranteeStatusCard
              contract={contract}
              ux={ux}
              onUploaded={onGuaranteeUploaded}
            />
          </Grid>
        ) : null}
      </Grid>

      {showPostActivation && ux.phase !== "active" ? (
        <ContractPostActivationCard />
      ) : null}
    </Stack>
  );
};

export default ContractorContractPageLayout;
